import { AccordionDetails as AccordionDetailsMaterial } from '@mui/material';
import { ReactElement } from 'react';

interface AccordionDetailsProps {
  children: ReactElement;
}

const AccordionDetails = ({ children }: AccordionDetailsProps): React.ReactElement => {
  return (
    <AccordionDetailsMaterial>
      <div className="pmi-mt-2">{children}</div>
    </AccordionDetailsMaterial>
  );
};

AccordionDetails.displayName = 'AccordionDetails detail component';

export default AccordionDetails;
